import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SparkleIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SparkleIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 20">
      <path
        d="M12.031 8.321a4.12 4.12 0 0 1 -4.136 -4.135A4.12 4.12 0 0 1 3.76 8.321a4.12 4.12 0 0 1 4.135 4.135 4.12 4.12 0 0 1 4.135 -4.135"
        stroke="#000"
        strokeWidth={0.42105263157894735}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.946 13.486A1.937 1.937 0 0 1 13 11.54a1.937 1.937 0 0 1 -1.946 1.946A1.937 1.937 0 0 1 13 15.432a1.937 1.937 0 0 1 1.946 -1.946"
        stroke="#000"
        strokeWidth={0.42105263157894735}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
export default SparkleIcon
